export default __webpack_public_path__ + "static/media/greenArrowUpLow.4794dc7b.svg";